import { render, staticRenderFns } from "./ListPlace.vue?vue&type=template&id=8570aa72&"
import script from "./ListPlace.vue?vue&type=script&lang=js&"
export * from "./ListPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports